import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import BtnCellRenderer from "../../common/BtnCellRenderer";
import { format } from "date-fns";
import { useHistory } from "react-router-dom";

import doctorActions from "../../../core/actions/doctorActions";
import Components from "../insurance/index";
import { patientActions } from "../../../core/actions";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions } from "@mui/material";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { insuranceActions } from "../../../core/actions";

function InsuranceMasterGrid(props) {
  let ids;
  const history = useHistory();
  const [pagination, setPagination] = useState(true);
  const [paginationPageSize, setPaginationPageSize] = useState(10);

  const [insuranceForm, setInsuranceData] = useState(false);
  const [insuranceRowData, setinsuranceRowData] = useState({});
  //   const [setinsuranceRow, setinsuranceRowData] = useState({});

  const [insuranceRowlist, setRowData] = useState();

  const dispatch = useDispatch();

  const [doctorList, setdoctorList] = useState({
    doctors: "",
  });

  const customComparator = (valueA, valueB) => {
    // let a= valueA.replace(/\s/g, '');
    // let b =valueB.replace(/\s/g, '');
    let a = valueA.trim();
    let b = valueB.trim();
    console.log("1", a);
    console.log("2", b);
    return a.toLowerCase().localeCompare(b.toLowerCase());
  };

  const [confirm, setConfirm] = useState(false);

  const [columnDefs] = useState([
    {
      headerName: "Company Name ",
      field: "companyName",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      comparator: customComparator,
      headerClass: "ag-header-left",
    },
    {
      headerName: "Email",
      field: "email",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      headerClass: "ag-header-left",
    },
    {
      headerName: "Contact 1",
      field: "phone1",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      onGridReady: "open",
      headerClass: "ag-header-left",
    },
    {
      headerName: "Contact 2",
      field: "phone2",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      headerClass: "ag-header-left",
    },
    {
      headerName: "Description.",
      field: "description",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      comparator: customComparator,
      headerClass: "ag-header-left",
    },

    {
      headerName: "Actions",
      field: "Actions",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      width: 150,
      cellRenderer: "BtnCellRenderer",
      headerClass: "ag-header-left",
    },
  ]);

  const closeModal = (event) => {
    setInsuranceData(!insuranceForm);
  };

  const getFormattedDate = (date) => {
    const reqdate = new Date(date);
    let formatteddate = format(reqdate, "MMM dd yyyy' 'HH:mm");
    return formatteddate;
  };

  const getFormatedReqtDate = (date) => {
    const reqtdate = new Date(date);
    // const apphours=new Date(date);
    //  const appminites= new Date(date);
    let formatedreqtdate = format(reqtdate, "MMM dd yyyy");
    //  let formatedappdate= format(appdate, "MMM dd yyyy",apphours,"HH",appminites,"MM" );
    return formatedreqtdate;
  };
  const getFormatedApptDate = (date) => {
    const apptdate = new Date(date);
    let formatedapptdate = format(apptdate, "MMM dd yyyy");
    return formatedapptdate;
  };

  const visitsList = useSelector(
    (state) => state.patientDetailsState.visitsList
  );
  console.log("visitsList", visitsList);

  const doctorlist = (data) => {
    dispatch(
      doctorActions.getDoctorsBasednId(data, (resCb) => {
        if (resCb) {
          setdoctorList(resCb);
          doctorList.doctors = resCb;
          console.log("list doctor Response:", doctorList);
        }
      })
    );
  };
  const [onmodal, setOnModal] = useState(true);
  const closemodalopen = () => {
    setOnModal(true);
  };
  const getAggriddata = (e) => {
    console.log("props", props);
    console.log("getAggriddata", e.data);

    if (e.colDef.field == "Actions") {
      setConfirm(!confirm);
      console.log("delete rowdata:", e.data);
      setTimeout(() => {
        setinsuranceRowData(e.data);
      }, 1000);
    } else {
      history.push("/insurancemaster", {
        rowData: e.data,
      });
    }
  };

  useEffect(() => {
    dispatch(patientActions.setPageHeader("insurance"));

    let data = {};
    console.log("props are:", props.insurancemaster);

    if (props && props.insurancemaster && props.insurancemaster.length > 0) {
      let pslist = props.insurancemaster;
      for (let item of pslist) {
        setRowData(pslist);
      }
    }
  }, [props]);

  const handleSubmit = (event) => {
    console.log("event", event);
    dispatch(
      insuranceActions.deleteInsurance(insuranceRowData, (resCb) => {
        if (resCb) {
          console.log("deleteTpa", resCb);
          // props.history.push("/tpamasterlist");
          setConfirm(!confirm);
          props.onGridAction("Insurance detail deleted successfully");
        }
      })
    );
  };

  const toggle = (event) => {
    setConfirm(!confirm);
  };

  const rowStyle = { background: "white" };

  return (
    <>
      {/* <h5 className="page-title my-2 mx-3">Doctors</h5> */}
      <div>
        <div className="p-0 preview">
          <div
            className="ag-theme-balham ag-style card rounded table mb-0 tcol"
            style={{ height: 500, width: `98%` }}
          >
            <AgGridReact
              frameworkComponents={{ BtnCellRenderer: BtnCellRenderer }}
              pagination={pagination}
              paginationPageSize={paginationPageSize}
              //   context={context}
              rowData={insuranceRowlist}
              columnDefs={columnDefs}
              // onRowClicked={(e) => getAggriddata(e)}
              rowStyle={rowStyle}
              //   getRowStyle={getRowStyle}
              onCellClicked={(e) => {
                console.log("event onCellclicked::", e);
                const field = e.colDef.field;
                const colIndex = e.columnApi
                  .getAllColumns()
                  ?.findIndex((col) => col.getColDef().field === field);

                console.log("cell clicked ", field, colIndex);
                getAggriddata(e);
              }}
            ></AgGridReact>
          </div>

          {confirm && (
            <div>
              <Dialog
                open={confirm}
                onClose={toggle}
                aria-labelledby="confirm-dialog-title"
                fullWidth
                maxWidth="sm" // or "xs" for smaller
                scroll="paper"
                PaperProps={{
                  sx: {
                    borderRadius: 2,
                    margin: { xs: 1, sm: 2 }, // responsive margin
                    width: "100%",
                  },
                }}
              >
                <DialogTitle
                  id="confirm-dialog-title"
                  sx={{
                    py: 2,
                    px: 3,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Confirm Operation
                  <IconButton
                    aria-label="close"
                    onClick={toggle}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                      ml: "auto",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>

                <DialogContent sx={{ px: 3, pb: 2 }}>
                  <Typography variant="body1" color="textSecondary">
                    This operation cannot be undone! Do you want to continue?
                  </Typography>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>
                  <Button
                    onClick={toggle}
                    variant="outlined"
                    color="inherit"
                    sx={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="error"
                    sx={{ textTransform: "none", ml: 1 }}
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default InsuranceMasterGrid;
